import Image from 'next/image';

export function SignInBtn({
  handleSignIn,
  width,
}: {
  handleSignIn: () => void;
  width?: string;
}) {
  const DEFAULT_WIDTH = 'w-40 sm:w-auto';

  const finalWidth = width ? width : DEFAULT_WIDTH;

  return (
    <div className={`flex ${finalWidth}`}>
      <button onClick={handleSignIn}>
        <Image
          priority
          alt="Google Signin"
          height={48}
          src={`${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/google-signin.webp`}
          width={200}
        />
      </button>
    </div>
  );
}
